module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.opened) ? _c('div', {
    staticClass: "contents"
  }, [(_vm.enableSearching) ? _c('search-venues', {
    attrs: {
      "venues": _vm.venues,
      "placeholder": "Search venues..."
    },
    on: {
      "search": function($event) {
        _vm.showSearchResults = $event
      },
      "results": function($event) {
        _vm.searchResults = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "scroll-height"
  }, [(_vm.loading) ? _vm._l((_vm.venueIds.length), function(n) {
    return _c('list-slot', {
      key: 'venuePlaceholder' + n,
      attrs: {
        "placeholder": "true"
      }
    })
  }) : _vm._e(), _vm._v(" "), (!_vm.showSearchResults) ? [_c('div', _vm._l((_vm.venues), function(venue) {
    return _c('list-slot', {
      key: venue.id,
      attrs: {
        "main-text": venue.name,
        "sub-text": venue.address,
        "disabled": false,
        "selected": false
      },
      on: {
        "click": function($event) {
          _vm.selectVenue(venue)
        }
      }
    })
  }))] : _vm._e(), _vm._v(" "), (_vm.showSearchResults) ? [_c('div', _vm._l((_vm.searchResults), function(venue) {
    return _c('list-slot', {
      key: venue.id + 'search',
      attrs: {
        "main-text": venue.name,
        "sub-text": venue.address,
        "disabled": false,
        "selected": false
      },
      on: {
        "click": function($event) {
          _vm.selectVenue(venue)
        }
      }
    })
  }))] : _vm._e()], 2)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fb8fa18","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/venueStage.vue
// module id = 581
// module chunks = 0